export default {
  quotes: [],
  quote: undefined,
};
